import type { PopupProps } from "./types";

import { createContext, useContext } from "react";

const SSOMarketingPopupContext = createContext<PopupProps | null>(null);

interface SSOMarketingPopupProviderProps extends PopupProps {
  children: React.ReactNode;
}

export const SSOMarketingPopupProvider = ({
  children,
  ...props
}: SSOMarketingPopupProviderProps) => {
  return (
    <SSOMarketingPopupContext.Provider value={props}>
      {children}
    </SSOMarketingPopupContext.Provider>
  );
};

export const useSSOMarketingPopupContext = () => {
  const popup = useContext(SSOMarketingPopupContext);
  if (!popup) {
    throw new Error(
      "useSSOMarketingPopupContext must be used within a SSOMarketingPopupProvider"
    );
  }
  return popup;
};
